import {
  BenefitsRoot,
  BenefitsContainer,
  Title,
  Description,
  ImageColumn,
  CopyColumn,
  CopyContainer,
  ImageWrapper,
  Subtitle,
} from './RecipeDetailBenefits.styles'
import { useTranslation } from 'hooks/useTranslation'
import Image, { StaticImageData } from 'next/image'
import { TranslationKeys } from 'locales/translationKeys'

export type RecipeDetailBenefitsProps = {
  imageSrc: StaticImageData
  list: TranslationKeys[]
  title: TranslationKeys
  imageAlt: TranslationKeys
  subtitle?: TranslationKeys
}

export const RecipeDetailBenefits = ({
  imageSrc,
  list,
  title,
  subtitle,
  imageAlt,
}: RecipeDetailBenefitsProps) => {
  const { t } = useTranslation()

  return (
    <BenefitsRoot>
      <BenefitsContainer>
        <CopyColumn>
          <CopyContainer>
            <Title>{t(title)}</Title>
            {subtitle && <Subtitle>{t(subtitle)}</Subtitle>}
            <Description>
              {list.map((benefit) => (
                <li key={benefit}>{t(benefit)}</li>
              ))}
            </Description>
          </CopyContainer>
        </CopyColumn>
        <ImageColumn>
          <ImageWrapper>
            <Image objectFit="cover" layout="fill" src={imageSrc} alt={t(imageAlt)} />
          </ImageWrapper>
        </ImageColumn>
      </BenefitsContainer>
    </BenefitsRoot>
  )
}

RecipeDetailBenefits.displayName = 'RecipeDetailBenefits'
